import { render } from "./objective.vue?vue&type=template&id=8f34b568&scoped=true&ts=true"
import script from "./objective.vue?vue&type=script&lang=ts"
export * from "./objective.vue?vue&type=script&lang=ts"

import "./objective.vue?vue&type=style&index=0&id=8f34b568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f34b568"]])

export default __exports__